import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';

const NoResultsOverlay = () => {
  const { t } = useTranslation('@mint-lib/labels-table');
  return (
    <div className="flex flex-col items-center gap-4">
      <Illustration
        className="size-40"
        component="IllustrationNoResults"
        aria-label="no-results-icon"
      />
      <div className="flex flex-col items-center gap-2">
        <span className={typographyVariants({ variant: 'h4' })}>
          {t('No results found')}
        </span>
        <span
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
          })}
        >
          {t('To add a new label, go to the settings page.')}
        </span>
      </div>
    </div>
  );
};

export { NoResultsOverlay };
